/* eslint-disable @typescript-eslint/no-inferrable-types */

export class CatalogTagsTranslation {
  // Properties
  public option : string = '';
  public default : string = 'undefined';
  public pt : string | undefined;
  public en : string | undefined;
  public fr : string | undefined;
  public es : string | undefined;
  public de : string | undefined;

  // Numeric constants
  public static TAG_MODEL = 2;
  public static TAG_TYPE = 3;
  public static TAG_GROUP = 4;
  public static TAG_FOLDER = 5;
  public static TAG_ROOT_OPTION = 5;
  public static TAG_FOLDER_OPTION = 6;
  public static TAG_DOMAIN = 4;
  public static TAG_DOMAIN_GROUP = 5;

  public static STATIC_STRINGS_PREFIX = '//$static/strings/';
  public static getStatictringKey(name: string) : string {
    return `${this.STATIC_STRINGS_PREFIX}${name}`;
  }

  public static getTranslation(
    tag :CatalogTagsTranslation | undefined,
    languange: string,
  ) : string | undefined {

    if (tag === undefined) return undefined;

    switch (languange.toLocaleLowerCase()) {
      case 'pt':
        return tag.pt ? tag.pt : tag.default;
        break;
      case 'en':
        return tag.en ? tag.en : tag.default;
        break;
      case 'fr':
        return tag.fr ? tag.fr : tag.default;
        break;
      case 'es':
        return tag.es ? tag.es : tag.default;
        break;
      case 'ge':
      case 'de':
        return tag.de ? tag.de : tag.default;
        break;
      default:
        return tag.default;
    }
  }
  public static evalModelTranslations(
    modelName: string,
    tagsTranslations: CatalogTagsTranslation[] | undefined,
  ) : CatalogTagsTranslation[] | undefined {
    if (tagsTranslations === undefined) return undefined;
    return tagsTranslations.filter((tag) => tag.option?.split('/')[CatalogTagsTranslation.TAG_MODEL] === modelName);
  }

  // The following assumes the input list is already filtered for model
  public static evalGroupTranslations(
    groupName: string,
    tagsTranslations: CatalogTagsTranslation[] | undefined,
  ) : CatalogTagsTranslation[] | undefined {
    if (tagsTranslations === undefined) return undefined;
    return tagsTranslations.filter((tag) => {
      const optParts = tag.option?.split('/');
      return (
        (
          optParts[CatalogTagsTranslation.TAG_TYPE] === 'group'
          || optParts[CatalogTagsTranslation.TAG_TYPE] === 'folder'
          || optParts[CatalogTagsTranslation.TAG_TYPE] === 'option'
        ) && (
          optParts[CatalogTagsTranslation.TAG_GROUP] === groupName
        )
      );
    });
  }

  public static evalModelGroupTrasnlation(
    modelName: string,
    groupName: string,
    tagsTranslations: CatalogTagsTranslation[] | undefined,
  ) : CatalogTagsTranslation[] | undefined {
    if (tagsTranslations === undefined) return undefined;
    return tagsTranslations.filter((tag) => {
      const optParts = tag.option?.split('/');
      return (
        (
          optParts[CatalogTagsTranslation.TAG_TYPE] === 'group'
          || optParts[CatalogTagsTranslation.TAG_TYPE] === 'folder'
          || optParts[CatalogTagsTranslation.TAG_TYPE] === 'option'
        ) && (
          optParts[CatalogTagsTranslation.TAG_MODEL] === modelName
          && optParts[CatalogTagsTranslation.TAG_GROUP] === groupName
        )
      );
    });
  }
  // The following assumes the input list is already filtered for model and group
  public static getGroupTranslation(
    groupName: string,
    tagsTranslations: CatalogTagsTranslation[] | undefined,
  ) : CatalogTagsTranslation | undefined {

    if (tagsTranslations === undefined) return undefined;
    const tags = tagsTranslations.filter((tag) => {
      const optParts = tag.option?.split('/');
      return (
        (
          optParts[CatalogTagsTranslation.TAG_TYPE] === 'group'
        ) && (
          optParts[CatalogTagsTranslation.TAG_GROUP] === groupName
        )
      );
    });
    if (tags.length > 0) return tags[0];
    return undefined;
  }

  // The following assumes the input list is already filtered for model and group
  public static getFolderTranslation(
    folderName: string,
    tagsTranslations: CatalogTagsTranslation[] | undefined,
  ) : CatalogTagsTranslation | undefined {

    if (tagsTranslations === undefined) return undefined;
    const tags = tagsTranslations.filter((tag) => {
      const optParts = tag.option?.split('/');
      return (
        (
          optParts[CatalogTagsTranslation.TAG_TYPE] === 'folder'
        ) && (
          optParts[CatalogTagsTranslation.TAG_FOLDER] === folderName
        )
      );
    });
    if (tags.length > 0) return tags[0];
    return undefined;
  }

  // The following assumes the input list is already filtered for model and group
  public static getRootOptionTranslation(
    optionName: string,
    tagsTranslations: CatalogTagsTranslation[] | undefined,
  ) : CatalogTagsTranslation | undefined {

    if (tagsTranslations === undefined) return undefined;
    const tags = tagsTranslations.filter((tag) => {
      const optParts = tag.option?.split('/');
      return (
        (
          optParts[CatalogTagsTranslation.TAG_TYPE] === 'option'
        ) && (
          optParts[CatalogTagsTranslation.TAG_ROOT_OPTION] === optionName
        )
      );
    });
    if (tags.length > 0) return tags[0];
    return undefined;
  }

  // The following assumes the input list is already filtered for model and group
  public static getFolderOptionTranslation(
    folderName: string,
    optionName: string,
    tagsTranslations: CatalogTagsTranslation[] | undefined,
  ) : CatalogTagsTranslation | undefined {

    if (tagsTranslations === undefined) return undefined;
    const tags = tagsTranslations.filter((tag) => {
      const optParts = tag.option?.split('/');
      return (
        (
          optParts[CatalogTagsTranslation.TAG_TYPE] === 'option'
        ) && (
          optParts[CatalogTagsTranslation.TAG_FOLDER] === folderName
          && optParts[CatalogTagsTranslation.TAG_FOLDER_OPTION] === optionName
        )
      );
    });
    if (tags.length > 0) return tags[0];
    return undefined;
  }
}
